import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const savedLanguage = window.localStorage.getItem('mesutronicLanguage');
const initialLanguage = savedLanguage === 'ru' || savedLanguage === 'kk' ? savedLanguage : 'kk';

i18n
  .use(initReactI18next)
  .init({
    lng: initialLanguage,
    supportedLngs: ['kk', 'ru'],
    fallbackLng: 'kk',
    debug: false,
    resources: {
      kk: { translation: {} },
      ru: { translation: {} },
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
